import { useNavigate } from 'react-router-dom';
import ContactUsModel from 'src/components/Modals/ContactUsModel';
import TermsAndConditionModal from 'src/components/Modals/TermsAndConditionModal';
import React, { useState } from 'react';
import moment from 'moment';
import '../CSS/AppFooter.css';
function AppFooter() {
  const navigate = useNavigate();
  const [ContactUsModal, setContactUsModal] = useState(false);
  const [termsmodalOpen, setTermsmodalOpen] = useState(false);

  const toggleContactUsMdl = () => setContactUsModal((prev) => !prev);
  const AddContactUsClick = () => toggleContactUsMdl(true);
  const TermsModal = () => setTermsmodalOpen((prev) => !prev);

  const toFbProfile = () =>
    window.open(
      'https://www.facebook.com/profile.php?id=61554023558745&is_tour_dismissed=true',
      '_blank',
    );
  const toInstaProfile = () => window.open('https://www.instagram.com/4Dims_official/', '_blank');
  const toTwitterProfile = () => window.open('https://x.com/@4Dims_official', '_blank');
  const toPlayStore = () =>
    window.open('https://play.google.com/store/apps/details?id=com.blazor.dsps', '_blank');
  const toAppleStore = () =>
    window.open('https://apps.apple.com/us/app/4-delivery-service-partners/id6618150968', '_blank');

  return (
    <React.Fragment>
      <footer className="footer-root">
        {/* Decorative top border */}
        <div className="footer-accent-bar" />

        <div className="footer-inner">
          {/* Column 1: Navigation Links */}
          <div className="footer-col footer-col--links">
            <span className="footer-col-heading">Quick Links</span>
            <nav className="footer-nav">
              <a className="footer-link" onClick={() => navigate('/dspRegister')}>
                <span className="footer-link-arrow">→</span> Register DSP
              </a>
              <a className="footer-link" onClick={() => navigate('/AddDA')}>
                <span className="footer-link-arrow">→</span> Apply as Delivery Associate
              </a>
              <a className="footer-link" href="#/faqs">
                <span className="footer-link-arrow">→</span> FAQs
              </a>
            </nav>
          </div>

          {/* Column 2: Brand + App Stores */}
          <div className="footer-col footer-col--brand">
            <div className="footer-logo-block">
              <span className="footer-brand-name">6BY7</span>
              {/* <span className="footer-brand-tagline">Delivering Tomorrow, Today.</span> */}
            </div>

            <div className="footer-stores">
              <button className="footer-store-btn" onClick={toAppleStore}>
                <img
                  src="AppStore.png"
                  alt="Download on the App Store"
                  className="footer-store-img"
                />
              </button>
              <button className="footer-store-btn" onClick={toPlayStore}>
                <img
                  src="GooglePlaystore.png"
                  alt="Get it on Google Play"
                  className="footer-store-img"
                />
              </button>
            </div>

            <div className="footer-socials">
              <button className="footer-social-btn" onClick={toInstaProfile} aria-label="Instagram">
                <img src="instagram.png" alt="Instagram" className="footer-social-icon" />
              </button>
              <button
                className="footer-social-btn footer-social-btn--x"
                onClick={toTwitterProfile}
                aria-label="X / Twitter"
              >
                <img
                  src="x.png"
                  alt="X"
                  className="footer-social-icon footer-social-icon--invert"
                />
              </button>
              <button className="footer-social-btn" onClick={toFbProfile} aria-label="Facebook">
                <img src="facebook.png" alt="Facebook" className="footer-social-icon" />
              </button>
            </div>
          </div>

          {/* Column 3: Legal + Contact */}
          <div className="footer-col footer-col--legal">
            <span className="footer-col-heading">Legal & Support</span>
            <nav className="footer-nav">
              <a className="footer-link" onClick={AddContactUsClick}>
                <span className="footer-link-arrow">→</span> Contact Us
              </a>
              <a className="footer-link" onClick={() => navigate('/PrivacyPolicy')}>
                <span className="footer-link-arrow">→</span> Policy Statement
              </a>
              <a className="footer-link" onClick={TermsModal}>
                <span className="footer-link-arrow">→</span> Terms of Use
              </a>
            </nav>
          </div>
        </div>

        {/* Bottom copyright bar */}
        <div className="footer-bottom">
          <span className="footer-copyright">
            © {moment().format('YYYY')} 6BY7. All Rights Reserved.
          </span>
        </div>
      </footer>

      <ContactUsModel isOpen={ContactUsModal} toggle={toggleContactUsMdl} header="Contact Us" />
      <TermsAndConditionModal isOpen={termsmodalOpen} toggle={TermsModal} />
    </React.Fragment>
  );
}

export default AppFooter;
